<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header align-items-center d-flex">
				<h4 class="card-title mb-0 flex-grow-1">Support Tickets</h4>
			</div>

			<div class="card-body">
				<div class="row mb-3 align-items-end">
					<div class="col-sm-4" style="overflow: visible; position: relative">
						<label>Date Range</label>
						<app-form-range-date
							[(ngModel)]="dateRange_"
							(OnSelected)="dateSelected($event)"
							[position]="'right'"
							[range_type]="'RANGE_PAST'"
							[autoApply]="true"
						></app-form-range-date>
					</div>
					<div class="col-sm-2">
						<button type="button" class="btn btn-primary" (click)="loadTickets()">
							Get Tickets
						</button>
					</div>
					<div class="col-sm-2">
						<label>Status</label>
						<select class="form-select" [(ngModel)]="statusFilter" (change)="applyFilters()">
							<option value="open">Open</option>
							<option value="resolved">Resolved</option>
							<option value="all">All</option>
						</select>
					</div>
					<div class="col-sm-4">
						<input
							type="text"
							class="form-control"
							placeholder="Filter by ticket #, reference, title, status..."
							[value]="searchText"
							(keyup)="updateFilter($event)"
						/>
					</div>
				</div>

				<!-- Loading -->
				<div *ngIf="loading" class="text-center py-5">
					<span class="spinner-border text-primary"></span>
				</div>

				<!-- Empty state -->
				<div *ngIf="!loading && rows.length === 0" class="text-center text-muted py-5">
					<i class="ri-customer-service-2-line" style="font-size: 3rem;"></i>
					<p class="mt-2">No tickets found.</p>
				</div>

				<!-- Cards grid -->
				<div *ngIf="!loading && rows.length > 0" class="row g-2">
					<div class="col-12" *ngFor="let ticket of pagedRows">
						<div
							class="ticket-card"
							[class.ticket-card--replacement]="isReplacement(ticket)"
							[class.ticket-card--reschedule]="isReschedule(ticket)"
							(click)="openTicket(ticket, ticketModalRef)"
						>
							<div
								class="ticket-avatar"
								[class.ticket-avatar--replacement]="isReplacement(ticket)"
								[class.ticket-avatar--reschedule]="isReschedule(ticket)"
							>
								<i [class]="isReplacement(ticket) ? 'ri-user-search-line' : isReschedule(ticket) ? 'ri-calendar-2-line' : 'ri-customer-service-2-line'"></i>
							</div>

							<div class="ticket-content">
								<span class="ticket-ref">{{ ticket.reference }}</span>
								<span
									class="ticket-title"
									[class.ticket-title--replacement]="isReplacement(ticket)"
									[class.ticket-title--reschedule]="isReschedule(ticket)"
								>
									{{ isReplacement(ticket) ? 'Revised Lead' : ticket.title }}
									<span *ngIf="(isReplacement(ticket) || isReschedule(ticket)) && ticket.lead_id" class="ticket-lead-id-inline" [class.ticket-lead-id-inline--reschedule]="isReschedule(ticket)">
										- Lead ID: {{ ticket.lead_id }}
									</span>
								</span>
								<p class="ticket-customer">
									<i class="ri-user-line me-1"></i>{{ ticket.user_name || 'Unknown' }}
								</p>
								<p class="ticket-message">
									{{ ticket.description | slice:0:80 }}{{ ticket.description?.length > 80 ? '...' : '' }}
								</p>
								<div class="ticket-footer">
									<i class="ri-time-line me-1"></i>
									<span>{{ ticket.updated_at | date:'MMM d, y · h:mm a' }}</span>
								</div>
							</div>

							<div class="d-flex flex-column align-items-end gap-1 flex-shrink-0 ms-auto">
								<span class="badge" [ngClass]="getStatusClass(ticket.status)">
									{{ ticket.status || 'N/A' | titlecase }}
								</span>
								<span *ngIf="ticket.waiting_for" class="badge" [ngClass]="getWaitingForClass(ticket.waiting_for)">
									{{ ticket.waiting_for | titlecase }}
								</span>
							</div>
						</div>
					</div>
				</div>

				<!-- Pagination -->
				<div *ngIf="!loading && totalPages > 1" class="d-flex justify-content-between align-items-center mt-4 flex-wrap gap-2">
					<small class="text-muted">
						Showing {{ (currentPage - 1) * pageSize + 1 }}–{{ min(currentPage * pageSize, rows.length) }} of {{ rows.length }} tickets
					</small>
					<nav>
						<ul class="pagination pagination-sm mb-0">
							<li class="page-item" [class.disabled]="currentPage === 1">
								<a class="page-link" (click)="goToPage(currentPage - 1)">
									<i class="ri-arrow-left-s-line"></i>
								</a>
							</li>
							<li
								class="page-item"
								*ngFor="let p of pageNumbers"
								[class.active]="p === currentPage"
							>
								<a class="page-link" (click)="goToPage(p)">{{ p }}</a>
							</li>
							<li class="page-item" [class.disabled]="currentPage === totalPages">
								<a class="page-link" (click)="goToPage(currentPage + 1)">
									<i class="ri-arrow-right-s-line"></i>
								</a>
							</li>
						</ul>
					</nav>
				</div>

			</div>
		</div>
	</div>
</div>

<!-- Ticket Detail Modal -->
<ng-template #ticketModal let-modal>
	<div class="modal-header d-flex align-items-center gap-2">
		<h4 class="modal-title me-2" id="modal-ticket-title">
			{{ selectedTicket?.reference }} — {{ selectedTicket?.title }}
		</h4>
		<span class="badge" [ngClass]="getStatusClass(selectedTicket?.status)">
			{{ (selectedTicket?.status | titlecase) || 'N/A' }}
		</span>
		<button type="button" class="btn-close ms-auto" aria-label="Close" (click)="modal.dismiss()"></button>
	</div>
	<div class="modal-body modal-body-flex p-0" *ngIf="selectedTicket">

		<!-- Main content -->
		<div class="modal-main">
		<ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs mb-3">

			<!-- Tab 1: Ticket Details -->
			<li [ngbNavItem]="1">
				<a ngbNavLink>Ticket Details</a>
				<ng-template ngbNavContent>

					<div class="row mb-2">
						<div class="col-6" *ngIf="selectedTicket.lead_id">
							<strong>Lead ID:</strong>
							<a [href]="'/#/lead-edit/' + selectedTicket.lead_id" target="_self"
							   class="badge bg-primary text-white text-decoration-none ms-1"
							   (click)="modal.dismiss()">
								{{ selectedTicket.lead_id }}
							</a>
						</div>
						<div [class]="selectedTicket.lead_id ? 'col-6' : 'col-12'">
							<strong>Customer:</strong> {{ selectedTicket.user_name || selectedTicket.user_id }}
						</div>
					</div>

					<div class="row mb-2">
						<div class="col-6">
							<strong>Created:</strong> {{ selectedTicket.created_at | date:'medium' }}
						</div>
						<div class="col-6">
							<strong>Updated:</strong> {{ selectedTicket.updated_at | date:'medium' }}
						</div>
					</div>

					<div class="row mb-2" *ngIf="selectedTicket.waiting_for">
						<div class="col-12">
							<strong>Waiting For:</strong>
							<span class="badge ms-2" [ngClass]="getWaitingForClass(selectedTicket.waiting_for)">
								{{ selectedTicket.waiting_for | titlecase }}
							</span>
						</div>
					</div>

					<div class="row mb-2" *ngIf="selectedTicket.resolved_by">
						<div class="col-12">
							<strong>Resolved By (ID):</strong> {{ selectedTicket.resolved_by }}
						</div>
					</div>

					<div class="row mb-3">
						<div class="col-12">
							<strong>Description:</strong>
							<div class="alert alert-light mt-1">{{ selectedTicket.description || '—' }}</div>
						</div>
					</div>

					<div class="row mb-3" *ngIf="selectedTicket.resolution">
						<div class="col-12">
							<strong>Resolution:</strong>
							<div class="alert alert-success mt-1">{{ selectedTicket.resolution }}</div>
						</div>
					</div>

					<hr />

					<div class="row mb-3">
						<div class="col-12">
							<strong>Chat History</strong>
							<div class="mt-2 chat-container">
								<div *ngIf="loadingChats" class="text-center py-2">
									<span class="spinner-border spinner-border-sm"></span> Loading chats...
								</div>
								<div *ngIf="!loadingChats && ticketChats.length === 0" class="text-muted text-center py-2">
									No messages yet.
								</div>
								<div
									*ngFor="let chat of ticketChats"
									class="chat-bubble mb-2"
									[ngClass]="chat.from_user_id === currentUserId ? 'bubble-me' : 'bubble-support'"
								>
									<div class="d-flex justify-content-between mb-1">
										<small class="chat-sender">
											{{ chat.from_user_id === currentUserId ? 'You' : 'Tech Support' }}
										</small>
										<small class="text-muted">{{ chat.created_at | date:'short' }}</small>
									</div>
									<div>{{ chat.message }}</div>
								</div>
							</div>
						</div>
					</div>

					<div class="row" *ngIf="messageSent">
						<div class="col-12">
							<div class="alert alert-success">
								Your message has been sent. Please wait for the admin's response.
							</div>
						</div>
					</div>

					<div class="row" *ngIf="!messageSent">
						<div class="col-12">
							<label class="form-label"><strong>Reply</strong></label>
							<textarea
								class="form-control"
								rows="4"
								placeholder="Write your answer..."
								[formControl]="answerMessage"
							></textarea>
						</div>
					</div>

				</ng-template>
			</li>

			<!-- Tab 2: Lead Info (reschedule / replacement only) -->
			<li [ngbNavItem]="2" *ngIf="isLeadTicket">
				<a ngbNavLink>Lead Info</a>
				<ng-template ngbNavContent>
					<div *ngIf="loadingLead" class="text-center py-4">
						<span class="spinner-border spinner-border-sm me-2"></span> Loading lead...
					</div>
					<div *ngIf="!loadingLead && !leadDetail" class="text-muted text-center py-4">
						No lead data available.
					</div>
					<div *ngIf="!loadingLead && leadDetail">

						<!-- Contact -->
						<div class="row mb-3">
							<div class="col-6">
								<label class="text-muted small mb-0">Prospect Name</label>
								<div class="fw-semibold">{{ leadDetail.prospect_name || '—' }}</div>
							</div>
							<div class="col-6">
								<label class="text-muted small mb-0">Company</label>
								<div class="fw-semibold">{{ leadDetail.prospect_company || '—' }}</div>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<label class="text-muted small mb-0">Email</label>
								<div class="fw-semibold">{{ leadDetail.email || '—' }}</div>
							</div>
							<div class="col-6">
								<label class="text-muted small mb-0">Primary Phone</label>
								<div class="fw-semibold">
									<a *ngIf="leadDetail.primary_phone; else noPhone"
									   [href]="'tel:' + leadDetail.primary_phone"
									   class="badge bg-success text-white text-decoration-none">
										{{ formatPhone(leadDetail.primary_phone) }}
									</a>
									<ng-template #noPhone>—</ng-template>
								</div>
							</div>
						</div>

						<hr class="my-2" />

						<!-- Address -->
						<div class="row mb-3">
							<div class="col-6">
								<label class="text-muted small mb-0">Address</label>
								<div class="fw-semibold">{{ leadDetail.address_1 || '—' }}</div>
							</div>
							<div class="col-3">
								<label class="text-muted small mb-0">State</label>
								<div class="fw-semibold">{{ leadDetail.state || '—' }}</div>
							</div>
							<div class="col-3">
								<label class="text-muted small mb-0">ZIP</label>
								<div class="fw-semibold">{{ leadDetail.zip || '—' }}</div>
							</div>
						</div>

						<hr class="my-2" />

						<!-- Business -->
						<div class="row mb-3">
							<div class="col-6">
								<label class="text-muted small mb-0">Campaign</label>
								<div class="fw-semibold">{{ leadDetail.campaign_name || '—' }}</div>
							</div>
							<div class="col-6">
								<label class="text-muted small mb-0">EIN</label>
								<div class="fw-semibold">{{ leadDetail.ein || '—' }}</div>
							</div>
						</div>

						<div class="row mb-3">
							<div class="col-6">
								<label class="text-muted small mb-0">Appt Date</label>
								<div class="fw-semibold">{{ leadDetail.date_generated | date:'mediumDate' }}</div>
							</div>
							<div class="col-6" *ngIf="leadDetail.replacement_status">
								<label class="text-muted small mb-0">Replacement / Reschedule Status</label>
								<div>
									<span class="badge"
										[ngClass]="{
											'bg-danger':    leadDetail.replacement_status === 'Denied Reschedule',
											'bg-info':      leadDetail.replacement_status === 'Pending Reschedule' || leadDetail.replacement_status === 'Rescheduled' || leadDetail.replacement_status === 'Pending Replacement' || leadDetail.replacement_status === 'Replaced',
											'bg-warning':   leadDetail.replacement_status === 'QC Calls' || leadDetail.replacement_status === 'Reschedule Request' || leadDetail.replacement_status === 'Replacement Request',
											'bg-secondary': leadDetail.replacement_status !== 'Denied Reschedule' && leadDetail.replacement_status !== 'Pending Reschedule' && leadDetail.replacement_status !== 'Rescheduled' && leadDetail.replacement_status !== 'Pending Replacement' && leadDetail.replacement_status !== 'Replaced' && leadDetail.replacement_status !== 'QC Calls' && leadDetail.replacement_status !== 'Reschedule Request' && leadDetail.replacement_status !== 'Replacement Request'
										}">
										{{ leadDetail.replacement_status }}
									</span>
								</div>
							</div>
						</div>


						<!-- Reschedule form — only when Reschedule Request -->
						<div *ngIf="leadDetail.replacement_status === 'Reschedule Request'" class="mt-3 p-3 border rounded">
							<h6 class="mb-3 text-muted">Reschedule Request</h6>
							<div class="d-flex flex-wrap gap-2">
								<button
									type="button"
									class="btn btn-warning btn-sm"
									[disabled]="rescheduleFreeLoading"
									(click)="confirmRescheduleFree()"
								>
									<span *ngIf="rescheduleFreeLoading" class="spinner-border spinner-border-sm me-1"></span>
									Approve Reschedule for Free
								</button>
								<button
									type="button"
									class="btn btn-warning btn-sm"
									[disabled]="rescheduleChargeLoading"
									(click)="confirmRescheduleCharge()"
								>
									<span *ngIf="rescheduleChargeLoading" class="spinner-border spinner-border-sm me-1"></span>
									Approve Reschedule with Fee
								</button>
								<button
									type="button"
									class="btn btn-outline-danger btn-sm"
									[disabled]="denyRescheduleLoading"
									(click)="denyReschedule()"
								>
									<span *ngIf="denyRescheduleLoading" class="spinner-border spinner-border-sm me-1"></span>
									Deny Reschedule
								</button>
							</div>
						</div>

						<!-- Reschedule form — only when Pending Reschedule -->
						<div *ngIf="leadDetail.replacement_status === 'Pending Reschedule'" class="mt-3 p-3 border rounded">
							<h6 class="mb-3 text-muted">Schedule New Appointment</h6>
							<div class="row g-2 align-items-end">

								<div class="col-12 col-md-4">
									<label class="form-label small mb-1">Date</label>
									<input
										type="date"
										class="form-control form-control-sm"
										[(ngModel)]="rescheduleDate"
									/>
								</div>

								<div class="col-4 col-md-2">
									<label class="form-label small mb-1">Hour</label>
									<select class="form-select form-select-sm" [(ngModel)]="rescheduleHour">
										<option *ngFor="let h of [1,2,3,4,5,6,7,8,9,10,11,12]"
											[value]="h < 10 ? '0' + h : '' + h">
											{{ h < 10 ? '0' + h : h }}
										</option>
									</select>
								</div>

								<div class="col-4 col-md-2">
									<label class="form-label small mb-1">Min</label>
									<select class="form-select form-select-sm" [(ngModel)]="rescheduleMin">
										<option value="00">00</option>
										<option value="15">15</option>
										<option value="30">30</option>
										<option value="45">45</option>
									</select>
								</div>

								<div class="col-4 col-md-2">
									<label class="form-label small mb-1">AM/PM</label>
									<select class="form-select form-select-sm" [(ngModel)]="rescheduleAmPm">
										<option value="AM">AM</option>
										<option value="PM">PM</option>
									</select>
								</div>

								<div class="col-12 col-md-2 d-flex align-items-end">
									<button
										type="button"
										class="btn btn-primary btn-sm w-100"
										[disabled]="rescheduleLoading || !rescheduleDate"
										(click)="submitReschedule()"
									>
										<span *ngIf="rescheduleLoading" class="spinner-border spinner-border-sm me-1"></span>
										Reschedule
									</button>
								</div>

							</div>
						</div>

						<!-- Replacement form only when it is Replacement Request  -->
						<div *ngIf="leadDetail.replacement_status === 'Replacement Request'" class="mt-3 p-3 border rounded">
							<h6 class="mb-3 text-muted">Replacement Request</h6>
							<div class="d-flex flex-wrap gap-2">
								<button
									type="button"
									class="btn btn-warning btn-sm"
									[disabled]="replacementFreeLoading"
									(click)="confirmReplacementFree()"
								>
									<span *ngIf="replacementFreeLoading" class="spinner-border spinner-border-sm me-1"></span>
									Approve Replacement for Free
								</button>
								<button
									type="button"
									class="btn btn-warning btn-sm"
									[disabled]="replacementChargeLoading"
									(click)="confirmReplacementCharge()"
								>
									<span *ngIf="replacementChargeLoading" class="spinner-border spinner-border-sm me-1"></span>
									Approve Replacement with Fee
								</button>
								<button
									type="button"
									class="btn btn-outline-danger btn-sm"
									[disabled]="denyReplacementLoading"
									(click)="denyReplacement()"
								>
									<span *ngIf="denyReplacementLoading" class="spinner-border spinner-border-sm me-1"></span>
									Deny Replacement
								</button>
							</div>
						</div>


						<!-- Replacement info — only when Replaced -->
						<div *ngIf="leadDetail.replacement_status === 'Replaced'" class="mt-3 p-3 border rounded border-success">
							<h6 class="mb-3 text-success">Replacement Lead</h6>
							<div class="row g-2 align-items-end">
								<div class="col-12 col-md-8">
									<label class="form-label small mb-1 text-muted">Replaced By</label>
									<div class="form-control form-control-sm bg-light">{{ leadDetail.replaced_by || '—' }}</div>
								</div>
								<div class="col-12 col-md-4 d-flex align-items-end">
									<button
										type="button"
										class="btn btn-outline-danger btn-sm w-100"
										[disabled]="unreplaceLoading"
										(click)="submitUnreplace()"
									>
										<span *ngIf="unreplaceLoading" class="spinner-border spinner-border-sm me-1"></span>
										Unreplace
									</button>
								</div>
							</div>
						</div>

						<!-- Replacement form — only when Pending Replacement -->
						<div *ngIf="leadDetail.replacement_status === 'Pending Replacement'" class="mt-3 p-3 border rounded">
							<h6 class="mb-3 text-muted">Assign Replacement Lead</h6>
							<div *ngIf="loadingReplacements" class="text-center py-2">
								<span class="spinner-border spinner-border-sm me-1"></span> Loading replacements...
							</div>
							<div *ngIf="!loadingReplacements">
								<div *ngIf="replacementLeads.length === 0" class="text-muted small mb-2">
									No replacement leads available.
								</div>
								<div *ngIf="replacementLeads.length > 0" class="row g-2 align-items-end">
									<div class="col-12 col-md-8">
										<label class="form-label small mb-1">Replacement Lead</label>
										<select class="form-select form-select-sm" [(ngModel)]="selectedReplacementAlias">
											<option value="">— Select a replacement —</option>
											<option *ngFor="let lead of replacementLeads" [value]="lead.id + ' - ' + lead.company_name">
												{{ lead.id }} - {{ lead.company_name }}
											</option>
										</select>
									</div>
									<div class="col-12 col-md-4 d-flex align-items-end">
										<button
											type="button"
											class="btn btn-primary btn-sm w-100"
											[disabled]="replacementLoading || !selectedReplacementAlias"
											(click)="submitReplacement()"
										>
											<span *ngIf="replacementLoading" class="spinner-border spinner-border-sm me-1"></span>
											Replace Lead
										</button>
									</div>
								</div>
							</div>
						</div>

					</div>
				</ng-template>
			</li>

		</ul>
		<div [ngbNavOutlet]="nav"></div>
		</div><!-- /modal-main -->

		<!-- Lifecycle Sidebar -->
		<div class="lifecycle-sidebar" *ngIf="isLeadTicket">
			<div class="sidebar-title">Lead Life Cycle</div>
			<app-lifecycle-cards [leadId]="selectedTicket.lead_id"></app-lifecycle-cards>
		</div>

	</div><!-- /modal-body -->
	<div class="modal-footer">
		<button
			type="button"
			class="btn me-auto"
			[class.btn-danger]="selectedTicket?.status !== 'resolved'"
			[class.btn-warning]="selectedTicket?.status === 'resolved'"
			[disabled]="changingStatus"
			(click)="confirmChangeStatus()"
		>
			<span *ngIf="changingStatus" class="spinner-border spinner-border-sm me-1"></span>
			{{ selectedTicket?.status === 'resolved' ? 'Mark as Unresolved' : 'Mark as Resolved' }}
		</button>
		<button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Close</button>
		<button
			*ngIf="!messageSent"
			type="button"
			class="btn btn-primary"
			[disabled]="sending || !answerMessage.value?.trim()"
			(click)="sendAnswer()"
		>
			<span *ngIf="sending" class="spinner-border spinner-border-sm me-1"></span>
			Send Answer
		</button>
	</div>
</ng-template>
